import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import callApi, { callDownload } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_DATA_PORTABILITY = 'FETCH_DATA_PORTABILITY';
export const FETCH_DATA_PORTABILITY_SUCCESS = 'FETCH_DATA_PORTABILITY_SUCCESS';
export const FETCH_DATA_PORTABILITY_FAIL = 'FETCH_DATA_PORTABILITY_FAIL';
export const IMPORT_DATA_PORTABILITY = 'IMPORT_DATA_PORTABILITY';
export const IMPORT_DATA_PORTABILITY_SUCCESS = 'IMPORT_DATA_PORTABILITY_SUCCESS';
export const IMPORT_DATA_PORTABILITY_FAIL = 'IMPORT_DATA_PORTABILITY_FAIL';

// Reducer
export default function dataPortabilityReducer(state = { data: [], loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_DATA_PORTABILITY:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_DATA_PORTABILITY_SUCCESS:
      return {
        ...state,
        ...payload,
        ...{
          data: [
            ...payload.data.reduce((accumulator, currentValue) => {
              if (['hcpc_medicare', 'hcpc_medicaid'].indexOf(currentValue.Route) !== -1) {
                if (accumulator.filter(item => item.Route === 'hcpc').length > 0) {
                  return accumulator;
                }
                return [
                  ...accumulator,
                  {
                    ID: currentValue.ID,
                    Route: 'hcpc',
                    Title: 'HCPCS Codes',
                  },
                ];
              }
              return [
                ...accumulator,
                currentValue,
              ];
            }, []),
            {
              ID: payload.data.length + 2,
              Route: 'payers',
              Title: 'Payers',
            },
          ],
        },
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_DATA_PORTABILITY_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchDataPortability(payload) {
  return { type: FETCH_DATA_PORTABILITY, payload };
}

export function fetchDataPortabilitySuccess(payload) {
  return { type: FETCH_DATA_PORTABILITY_SUCCESS, payload };
}

export function fetchDataPortabilityFail(payload) {
  return { type: FETCH_DATA_PORTABILITY_FAIL, payload };
}

export function importDataPortability(payload) {
  return { type: IMPORT_DATA_PORTABILITY, payload };
}

export function importDataPortabilitySuccess(payload) {
  return { type: IMPORT_DATA_PORTABILITY_SUCCESS, payload };
}

export function importDataPortabilityFail(payload) {
  return { type: IMPORT_DATA_PORTABILITY_FAIL, payload };
}

// Requests
export function requestFetchDataPortability() {
  return callApi('portability/portability_variants/');
}

export function requestDownloadDataPortabilityExample(ID) {
  return callDownload(`portability/download/${ID}/example/`, 'GET', `${ID}-example`);
}

export function requestDownloadDataPortabilityTemplate(ID) {
  return callDownload(`portability/download/${ID}/template/`, 'GET', `${ID}-template`);
}

export function requestImportDataPortability({ ID, File }) {
  const formData = new FormData();
  formData.append('file', File);
  return callApi(`portability/upload/${ID}/`, 'POST', formData, false);
}

// Sagas
function* fetchDataPortabilitySaga(action) {
  const { triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchDataPortability);
    yield put(fetchDataPortabilitySuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchDataPortabilityFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* importDataPortabilitySaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestImportDataPortability, values);
    yield put(importDataPortabilitySuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: res.data.result,
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(importDataPortabilityFail(err.data));
    yield put(addNotification({
      message: err.data.error || err.data,
      variant: 'warning',
    }));
    if (reject) {
      reject(err.data.error || err.data);
    }
  }
}

export function* dataPortabilitySaga() {
  yield takeLatest(FETCH_DATA_PORTABILITY, fetchDataPortabilitySaga);
  yield takeEvery(IMPORT_DATA_PORTABILITY, importDataPortabilitySaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/dataPortability.js